<template>
  <div class="product-price-manager">
    <h3>Alt Domain Kampanya Fiyatları</h3>

    <p style="color: red;">
      Bu fiyatlar landing sitelerindeki “Kampanya Fiyatı X₺ Yerine Y₺” alanına yazılır.
      <b>site_key</b> klasör adıyla aynı olmalı (örn. microblading → microblading.refikaguzellik.com).
      Güncelleme sonrası siteler otomatik senkronlanır; Vue build gerekmez.
    </p>

    <form @submit.prevent="isEditMode ? updateProductPrice() : addProductPrice()">
      <h4>{{ isEditMode ? 'Fiyatı Güncelle' : 'Yeni Fiyat Ekle' }}</h4>

      <label>Ad</label>
      <input v-model="formData.name" placeholder="Microblading" required />

      <label>Site Key</label>
      <input
        v-model="formData.site_key"
        placeholder="microblading"
        required
        :disabled="isEditMode"
      />

      <label>Normal Fiyat</label>
      <input v-model="formData.price" type="number" step="1" placeholder="12000" required />

      <label>Kampanya Fiyatı</label>
      <input v-model="formData.sale_price" type="number" step="1" placeholder="8500" required />

      <button type="submit">{{ isEditMode ? 'Güncelle' : 'Ekle' }}</button>
      <button v-if="isEditMode" type="button" @click="cancelEdit">İptal</button>
      <button type="button" @click="syncSites">Siteleri Senkronize Et</button>
    </form>

    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>Ad</th>
          <th>Site Key</th>
          <th>Normal</th>
          <th>Kampanya</th>
          <th>İşlemler</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="product in products" :key="product.id">
          <td>{{ product.id }}</td>
          <td>{{ product.name }}</td>
          <td>{{ product.site_key }}</td>
          <td>{{ product.price }}</td>
          <td>{{ product.sale_price }}</td>
          <td>
            <button @click="editProduct(product)">Düzenle</button>
            <button @click="deleteProduct(product.id)">Sil</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      products: [],
      isEditMode: false,
      formData: {
        id: null,
        name: "",
        site_key: "",
        price: null,
        sale_price: null,
      },
    };
  },
  created() {
    this.fetchProducts();
  },
  methods: {
    async fetchProducts() {
      try {
        const response = await axios.get("/admin/refika/subdomainprices");
        this.products = response.data.data || [];
      } catch (error) {
        console.error("Alt domain fiyatları alınırken hata oluştu:", error);
      }
    },
    async addProductPrice() {
      try {
        await axios.post("/admin/refika/subdomainprices", this.formData);
        this.fetchProducts();
        this.resetForm();
        alert("Eklendi ve siteler güncellendi.");
      } catch (error) {
        console.error("Eklenirken hata:", error);
        alert("Ekleme başarısız.");
      }
    },
    async updateProductPrice() {
      try {
        await axios.put(`/admin/refika/subdomainprices/${this.formData.id}`, this.formData);
        this.fetchProducts();
        this.resetForm();
        alert("Güncellendi ve siteler senkronlandı.");
      } catch (error) {
        console.error("Güncellenirken hata:", error);
        alert("Güncelleme başarısız.");
      }
    },
    async deleteProduct(id) {
      try {
        if (confirm("Bu kaydı silmek istediğinizden emin misiniz?")) {
          await axios.delete(`/admin/refika/subdomainprices/${id}`);
          this.fetchProducts();
        }
      } catch (error) {
        console.error("Silinirken hata:", error);
      }
    },
    async syncSites() {
      try {
        const res = await axios.post("/admin/refika/subdomainprices/sync");
        alert(res.data.message || "Senkron tamam.");
      } catch (error) {
        console.error("Senkron hatası:", error);
        alert("Senkron başarısız.");
      }
    },
    editProduct(product) {
      this.isEditMode = true;
      this.formData = {
        id: product.id,
        name: product.name,
        site_key: product.site_key,
        price: product.price,
        sale_price: product.sale_price,
      };
    },
    cancelEdit() {
      this.resetForm();
    },
    resetForm() {
      this.isEditMode = false;
      this.formData = {
        id: null,
        name: "",
        site_key: "",
        price: null,
        sale_price: null,
      };
    },
  },
};
</script>

<style scoped>
.product-price-manager {
  padding: 20px;
}
</style>
